import {
  createVerticalLinearGradient,
  hexToRGBA,
} from 'react-stockcharts/lib/utils';

export const GradientConfig = {
  Dark: {
    gradient: createVerticalLinearGradient([
      { stop: 0, color: hexToRGBA('#1a76cf', 0.5) },
      { stop: 1, color: hexToRGBA('#020203', 0.5) },
    ]),
    strokeColor: '#9adbff',
  },

  Light: {
    gradient: createVerticalLinearGradient([
      { stop: 0, color: hexToRGBA('#5dc5f6', 0.5) },
      { stop: 1, color: hexToRGBA('#5568de', 0.5) },
    ]),
    strokeColor: '#0060ff',
  },

  Classic: {
    gradient: createVerticalLinearGradient([
      { stop: 0, color: hexToRGBA('#1a76cf', 0.5) },
      { stop: 1, color: hexToRGBA('#020203', 0.5) },
    ]),
    strokeColor: '#9adbff',
  },
};

export const XAxisConfig = {
  Dark: '#1a1a1a',
  Light: '#2b457d',
  Classic: '#2d2a3c',
};
